const formatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: 'UTC',
});

/** Format a date as "DD/MM/YYYY" in UTC */
export const formatDDMMYYYYUtc = (date: Date | string): string => {
  const parts = formatter.formatToParts(new Date(date));
  const getPart = (type: Intl.DateTimeFormatPart['type']) =>
    parts.find((part) => part.type === type)?.value ?? '';

  return `${getPart('day')}/${getPart('month')}/${getPart('year')}`;
};
